import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

// Query keys
export const organizationKeys = {
  all: ['organizations'],
  lists: () => [...organizationKeys.all, 'list'],
  list: (filters) => [...organizationKeys.lists(), filters],
  details: () => [...organizationKeys.all, 'detail'],
  detail: (id) => [...organizationKeys.details(), id],
};

// Fetch all organizations
export function useOrganizations(filters = {}, options = {}) {
  return useQuery({
    queryKey: organizationKeys.list(filters),
    queryFn: () => apiHelper.getResource('/org/organizations/'),
    // queryFn: () => api.get('/org/sys/organization/'),
    ...options,
  });
}

// Fetch single organization
export function useOrganization(id) {
  return useQuery({
    queryKey: organizationKeys.detail(id),
    queryFn: () => apiHelper.getResource(`/org/organizations/${id}/`),
    // queryFn: () => api.get(`/org/sys/organization/${id}/`),
    enabled: !!id,
  });
}

// Create organization
export function useCreateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => apiHelper.postResource('/org/organizations/', data),
    // mutationFn: (data) => api.post('/org/sys/organization/', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: organizationKeys.lists() });
    },
  });
}

// Update organization
export function useUpdateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => apiHelper.putResource(`/org/organizations/${id}/`, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: organizationKeys.lists() });
      queryClient.invalidateQueries({ queryKey: organizationKeys.detail(id) });
    },
  });
}

// Delete organization
export function useDeleteOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => apiHelper.deleteResource(`/org/organizations/${id}/?confirm=yes`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: organizationKeys.lists() });
    },
  });
}
